import { useTimezoneSelect } from 'react-timezone-select';

export const useTimezones = () => {
  const timezones = {
    'America/New_York': 'Eastern Time',
    'America/Chicago': 'Central Time',
    'America/Boise': 'Mountain Time',
    'America/Phoenix': 'Arizona',
    'America/Los_Angeles': 'Pacific Time',
    'America/Juneau': 'Alaska',
    'Pacific/Honolulu': 'Hawaii',
    'Pacific/Midway': 'Midway Island, Samoa',
    'America/St_Johns': 'Newfoundland and Labrador'
  };

  const { options: timezoneOptions, parseTimezone } = useTimezoneSelect({
    labelStyle: 'original',
    displayValue: 'GMT',
    timezones: timezones
  });

  return { timezoneOptions, parseTimezone };
};
